import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Api, BaseUrl, ImagePath } from "../../Config/Api";
import { toast } from "react-toastify";
import { COLOR, FONT, IMAGE } from "../../Config/Color";
import { Table} from "antd";
import MainLayout from "../../../layouts/MainLayout";
import { useDispatch } from "react-redux";
import { getEmployeeProfile } from "../../../redux/actions/employeeActions";
import { useSelector } from "react-redux";
import ProfileDetailsCard from "../../Component/ProfileDetailsCard";
const EmployeeSalaryNew = () => {
  const employeeId = sessionStorage.getItem("employeeId");
  const token = sessionStorage.getItem("authToken");
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"))||{}
  const setLoading = () => { };
  const logout = () => { };
  const [employeeSalary, setEmployeeSalary] = useState([]);
  const dispatch = useDispatch()
  const profileData = useSelector((state) => state.employeeData?.profile)
  useEffect(() => {
    if (employeeId && (!profileData?.name)) {
      dispatch(getEmployeeProfile(employeeId))
      // getEmployeeSalaryDetails(employeeId)

    }
  }, []);
  const getEmployeeSalaryDetails = useCallback(
    async (data) => {
      setLoading(true);

      try {
        const responseData = await axios.get(
          `${BaseUrl}${Api.GET_EMPLOYEE_SALARY}?employee_id=${employeeId}`,
          {
            headers: {
              "X-Company-ID":userDetails.company_id,
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (responseData?.data?.authenticated === false) {
          toast.error(responseData?.data?.mssg[0], {
            position: "top-center",
            autoClose: 1000,
          });
          logout();
        } else {
          if (responseData?.data?.valid === false) {
            toast.error(responseData?.data?.mssg[0], {
              position: "top-center",
              autoClose: 1000,
            });
            setLoading(false);
          } else if (responseData?.data?.success == true) {
            setEmployeeSalary(responseData?.data?.data);
            setLoading(false);
          } else {
            setEmployeeSalary([]);
            setLoading(false);
          }
        }
      } catch (error) {
        setLoading(false);
        console.error("API call failed:", error);
        toast.error("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [token, setLoading, logout]
  );
  useEffect(() => {
    getEmployeeSalaryDetails();
  }, []);
  const columns = [
    {
      title: "S.NO",
      dataIndex: "sn",

      key: "sn",
      render: (_, record, index) => (
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >

          {index + 1}
        </div>
      ),
    },
    {
      title: "NAME",
      dataIndex: "name",
      filterMultiple: true,
      key: "name",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "20px",
            color: COLOR.GRAY4,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "MONTH",
      dataIndex: "month",
      key: "month",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "YEAR",
      dataIndex: "year",
      key: "year",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "PAID LEAVE",
      dataIndex: "paid_leave",
      key: "paid_leave",
      render: (_, record) => {
        const totalPaidLeave = (Number(record.paid_full_day) || 0) + (Number(record.paid_half_day) || 0);
        return (
          <span
            style={{
              //fontFamily: "Inter",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "22px",
              color: COLOR.GRAY3,
            }}
          >
            {totalPaidLeave}
          </span>
        );
      },
    },
    {
      title: "UNPAID LEAVE",
      dataIndex: "unPaidLeave",
      key: "unPaidLeave",
      render: (_, record) => {
        const totalPaidLeave =
          (record.unaprove_full_day || 0) +
          (record.unaprove_half_day || 0) +
          (record.unpaid_full_day || 0) +
          (record.unpaid_half_day || 0);

        return (
          <span
            style={{
              //fontFamily: "Inter",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "22px",
              color: COLOR.GRAY3,
            }}
          >
            {totalPaidLeave.toString()}
          </span>
        );
      },
    },
    {
      title: "TOTAL LATE",
      dataIndex: "lateCount",
      key: "lateCount",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },


    {
      title: "TOTAL LEAVE",
      dataIndex: "total_Leave",
      key: "total_Leave",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "TOTAL DAYS",
      dataIndex: "total_days",
      key: "total_days",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "TOTAL DEDUCTION",
      dataIndex: "total_salary_deduction",
      key: "total_salary_deduction",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "TOTAL SALARY DAYS",
      dataIndex: "salary_days",
      key: "salary_days",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
  ];

  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <h2
            style={{
              marginBottom: "10px",
              marginTop: "10px",
              fontSize: "24px",
              fontWeight: "700",
              //fontFamily: "Inter",
              color: COLOR.BLACK,
            }}
          >
            Salary Page
          </h2>
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                maxHeight: "90vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <ProfileDetailsCard style={{position:"relative" ,top:"0",width:"100%"}}/>

              <div className="p-4 rounded-lg bg-white shadow-sm mt-5">
                <div className="flex items-center justify-between ">
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      //fontFamily: "Inter",
                      color: COLOR.BLACK,
                      lineHeight: "20px",
                    }}
                  >
                    Salary Details History
                  </h3>


                </div>


                <div
                  style={{
                    marginTop: "20px",
                    width: "100%",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    overflowX: "auto",
                  }}
                >

                  <Table
                    className="dotted-border-table"
                    columns={columns}
                    dataSource={employeeSalary}
                    pagination={{ pageSize: 8 }}
                    rowClassName={() => "custom-row"}
                    bordered={false}
                    style={{ tableLayout: "fixed" }}
                    rowKey="key"
                    locale={{
                      emptyText: (
                        <div className="custom-no-data">
                          No Salary History Data Found
                        </div>
                      ),
                    }}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EmployeeSalaryNew;
